export const readField = (obj, ...keys) => {
    if (!obj || typeof obj !== 'object') return undefined
    for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i]
        if (obj[key] !== undefined && obj[key] !== null) return obj[key]
    }
    return undefined
}

export const asArray = value => (Array.isArray(value) ? value : [])

export const monthKeyOf = month => {
    const year = Number(readField(month, 'Year', 'year'))
    const monthNum = Number(readField(month, 'Month', 'month'))
    if (!Number.isInteger(year) || !Number.isInteger(monthNum)) return ''
    return `${year}-${monthNum}`
}

export const parseMonthKey = key => {
    const [year, month] = String(key || '').split('-')
    const yearNum = Number(year)
    const monthNum = Number(month)
    if (!Number.isInteger(yearNum) || !Number.isInteger(monthNum)) return null
    return { Year: yearNum, Month: monthNum }
}

export const customerValueOf = id => `c:${Number(id)}`

export const parseCustomerValue = value => {
    const raw = String(value || '')
    if (!raw.startsWith('c:')) return null
    const id = Number(raw.slice(2))
    if (!Number.isInteger(id) || id < 0) return null
    return id
}

export const auditCountLabel = count => {
    const n = Number(count)
    if (!Number.isInteger(n) || n < 0) return ''
    return `${n} ${n === 1 ? 'audit' : 'audits'}`
}

export const monthOptionLabel = month => {
    const label = readField(month, 'Label', 'label') || 'Month'
    const audits = readField(month, 'Audits', 'audits')
    const countLabel = auditCountLabel(audits)
    return countLabel ? `${label} · ${countLabel}` : label
}

export const scoreTone = value => {
    if (value === null || value === undefined || value === '') return 'empty'
    const n = Number(value)
    if (Number.isNaN(n)) return 'empty'
    if (n >= 90) return 'green'
    if (n >= 75) return 'amber'
    return 'red'
}

export const formatKpiPct = value => {
    if (value === null || value === undefined || value === '') return '–'
    const n = Number(value)
    if (Number.isNaN(n)) return '–'
    return `${n.toFixed(1)}%`
}

export const formatScorePct = value => {
    if (value === null || value === undefined || value === '') return '–'
    const n = Number(value)
    if (Number.isNaN(n)) return '–'
    return `${Math.round(n)}%`
}

export const formatDelta = value => {
    if (value === null || value === undefined || value === '') return null
    const n = Number(value)
    if (Number.isNaN(n) || n === 0) return null
    return {
        direction: n < 0 ? 'down' : 'up',
        points: Math.abs(n).toFixed(1),
    }
}

export const readApiError = err => {
    const status = Number(err?.status) || 0
    const payload =
        err?.error && typeof err.error === 'object' ? err.error : {}
    const messageFromPayload =
        readField(payload, 'Message', 'message', 'ErrorMessage', 'errorMessage') ||
        ''
    const message =
        (typeof messageFromPayload === 'string' && messageFromPayload.trim()) ||
        (typeof err?.error === 'string' ? err.error.trim() : '') ||
        ''
    const field = String(readField(payload, 'Field', 'field') || '')
    const code = String(
        readField(payload, 'ErrorCode', 'errorCode', 'Code', 'code') || '',
    )
    const notAllowed =
        status === 403 || /notallowed/i.test(code)
    let display = message
    if (field && display && !display.toLowerCase().includes(field.toLowerCase())) {
        display = `${field}: ${display}`
    }
    if (!display) {
        if (status === 400) display = 'Check the report type, year, and month.'
        else if (notAllowed) display = 'You do not have access to this report.'
        else display = 'Could not load the Process Health report.'
    }
    return { status, message: display, field, code, notAllowed }
}

export const buildReportBody = ({
    reportType,
    monthKey,
    customerValues,
    includePdf,
}) => {
    const month = parseMonthKey(monthKey)
    if (!month) return null
    const customerIds =
        reportType === 'ByCustomer'
            ? []
            : (customerValues || [])
                  .map(parseCustomerValue)
                  .filter(id => id !== null)
    return {
        ReportType: reportType,
        Year: month.Year,
        Month: month.Month,
        CustomerIds: customerIds,
        IncludePdf: Boolean(includePdf),
    }
}

export const reportDataOf = result =>
    readField(result, 'Data', 'data') || null

export const pdfUrlOf = result =>
    readField(result, 'PdfUrl', 'pdfUrl', 'PDFUrl') || ''
